export default "__VITE_ASSET__DqnbIkR6__"